<template>
  <div>
    <div class="wrapper">
      <comheader :index="2"></comheader>

      <main id="content" role="main">
        <input type="hidden" name="hdnAgeText" id="hdnAgeText" value="Age" />
        <input
          type="hidden"
          name="hdnDateTimeText"
          id="hdnDateTimeText"
          value="Date Time (UTC)"
        />
        <input
          type="hidden"
          name="hdnAgeTitle"
          id="hdnAgeTitle"
          value="Click to show Age Format"
        />
        <input
          type="hidden"
          name="hdnDateTimeTitle"
          id="hdnDateTimeTitle"
          value="Click to show Datetime Format"
        />
        <input
          type="hidden"
          name="hdnTxnText"
          id="hdnTxnText"
          value="Txn Fee"
        />
        <input
          type="hidden"
          name="hdnGasPriceText"
          id="hdnGasPriceText"
          value="Gas Price"
        />
        <input
          type="hidden"
          name="hdnTxnFeeTitle"
          id="hdnTxnFeeTitle"
          value="(Gas Price * Gas Used by Txns) in Ether"
        />
        <input
          type="hidden"
          name="hdnGasPriceTitle"
          id="hdnGasPriceTitle"
          value="Gas Price in Gwei"
        />
        <div class="container py-3" v-if="isShowAddress">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center"
          >
            <div class="mb-3 mb-lg-0">
              <h1 class="h4 mb-0">
                <span v-if="ifContract"> Contract </span>
                <span v-if="!ifContract"> Address </span>
                <span
                  id="mainaddress"
                  class="text-size-address text-secondary text-break mr-1"
                  data-placement="top"
                  v-clipboard:copy="addr"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >{{ addr }}</span
                >
                <el-tooltip
                  :content="'Copy From Address to clipboard'"
                  placement="top"
                >
                  <a
                    class="js-clipboard text-muted ml-1"
                    href="javascript:;"
                    v-clipboard:copy="addr"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <span
                      id="fromAddressLinkIcon"
                      class="far"
                      :class="{
                        'fa-copy': !isSuccess_copy,
                        'fa-check-circle-o': isSuccess_copy,
                      }"
                    ></span>
                  </a>
                </el-tooltip>
                <span
                  class="text-size-address text-secondary text-break mr-1"
                  >{{ isSuccess_copy ? "&nbsp;Copied" : "" }}</span
                >
                <!-- 
                <span
                  id="ContentPlaceHolder1_copyButtonPanel"
                  class="d-inline-flex"
                >
                  <span class="mr-1">
                    <a
                      class="
                        js-clipboard
                        btn btn-sm btn-icon btn-soft-secondary
                        rounded-circle
                        disabled
                      "
                      id="copyaddressbutton"
                      href="javascript:;"
                      data-toggle="tooltip"
                      data-title="Copy address to clipboard"
                      data-content-target=" #mainaddress"
                      data-class-change-target="#linkIcon"
                      data-type="tooltip"
                      data-success-text="Copied"
                      data-default-class="far fa-copy"
                      data-success-class="fa fa-check"
                    >
                      <span
                        id="linkIcon"
                        class="far fa-copy btn-icon__inner"
                      ></span>
                    </a>
                  </span>
                </span> -->
              </h1>
              <div class="mt-1"></div>
            </div>
          </div>
        </div>
        <div class="container" v-if="!isShowAddress">
          <div
            class="d-md-flex justify-content-between align-items-center py-3"
          >
            <div class="mb-1 mb-md-0">
              <h1 class="h4 mb-0">
                Transactions&nbsp;<span class="small text-secondary"></span>
                <p class="mb-0 text-break small" v-if="flag == 1">
                  <span
                    id="ContentPlaceHolder1_divPageTitle"
                    class="small text-secondary d-flex mt-1"
                  >
                    For Block
                    {{ height }}
                  </span>
                </p>
              </h1>
            </div>
          </div>
        </div>

        <div class="container space-bottom-2">
          <div class="row mb-4" v-if="addr != undefined">
            <div class="col-md-6 mb-3 mb-md-0">
              <div class="card h-100">
                <div
                  class="
                    card-header
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <h2 class="card-header-title">Overview</h2>
                  <div></div>
                </div>

                <div class="card-body" v-if="prc_decimal == ''">
                  <div class="row align-items-center">
                    <div class="col-md-4 mb-1 mb-md-0">Balance:</div>
                    <div class="col-md-8">{{ balance }} Psc</div>
                  </div>

                  <hr class="hr-space" />

                  <div class="row align-items-center">
                    <div class="col-md-4 mb-1 mb-md-0">
                      <span class="d-md-none d-lg-inline-block mr-1">Psc</span
                      >Value:
                    </div>
                    <div class="col-md-8">{{ pscValue }}</div>
                  </div>

                  <hr class="hr-space" />

                  <div
                    class="row align-items-center"
                    v-if="tokenList.length != 0 && !is_pool"
                  >
                    <div class="col-md-4 mb-1 mb-md-0">Token:</div>
                    <div class="col-md-8 d-flex justify-content-between">
                      <div class="position-relative w-100 mr-1">
                        <a
                          id="availableBalanceDropdown"
                          class="
                            btn btn-xs btn-custom btn-custom-balance
                            dropdown-toggle
                          "
                          href="javascript:;"
                          role="button"
                          aria-controls="basicDropdownClick"
                          aria-haspopup="true"
                          aria-expanded="true"
                          data-unfold-target="#availableBalanceClick"
                          data-unfold-type="css-animation"
                          data-unfold-duration="300"
                          data-unfold-delay="300"
                          data-unfold-hide-on-scroll="false"
                          data-unfold-animation-in="slideInUp"
                          data-unfold-animation-out="fadeOut"
                          @click="ifSlideInUp"
                        >
                          <span
                            class="badge badge-primary mx-1"
                            data-toggle="tooltip"
                            title=""
                            data-original-title="More than 102 token contracts found, but displaying the first 100 only"
                            >{{ tokenList.length }}</span
                          >
                        </a>
                        <div
                          id="availableBalanceClick"
                          class="
                            dropdown-menu dropdown-unfold dropdown-balance
                            w-100
                            u-unfold--css-animation u-unfold--hidden
                          "
                          aria-labelledby="availableBalanceDropdown"
                          style="animation-duration: 300ms; left: 0px"
                        >
                          <div class="pl-2 pr-3 js-focus-state">
                            <input
                              type="text"
                              class="form-control form-control-xs search mb-3"
                              placeholder="Search for Token Name"
                              aria-label="Search for Token name"
                              aria-describedby="filter-search"
                              v-model="s_token_name"
                            />
                          </div>
                          <div
                            class="
                              js-scrollbar
                              overflow-hidden
                              pl-2
                              pr-3
                              mCustomScrollbar
                              _mCS_1
                              mCS-autoHide
                            "
                            style="
                              max-height: 280px;
                              position: relative;
                              overflow: visible;
                            "
                          >
                            <div
                              id="mCSB_1"
                              class="
                                mCustomScrollBox
                                mCS-minimal-dark
                                mCSB_vertical mCSB_outside
                              "
                              style="max-height: 280px"
                              tabindex="0"
                            >
                              <div
                                id="mCSB_1_container"
                                class="mCSB_container"
                                style="position: relative; top: 0; left: 0"
                                dir="ltr"
                              >
                                <div
                                  class="list-not-found text-center pt-5"
                                  style="display: none"
                                >
                                  <img
                                    class="mb-4 mCS_img_loaded"
                                    width="100"
                                    src="/assets/svg/empty-states/empty-search-state.svg"
                                    alt="Search Not Found"
                                  />
                                  <p class="lead mb-0">
                                    Could not find any matches!
                                  </p>
                                </div>
                                <div
                                  id="list-not-found-more-than"
                                  class="text-center pt-5"
                                  style="display: none"
                                >
                                  <img
                                    class="mb-4 mCS_img_loaded"
                                    width="100"
                                    src="/assets/svg/empty-states/empty-search-state.svg"
                                    alt="Search Not Found"
                                  />
                                  <p class="lead mb-0">
                                    Token display limit reached. Click to
                                    <a
                                      href="javascript:;"
                                      onclick="hrefTokenHolding()"
                                      data-toggle="tooltip"
                                      title=""
                                      data-original-title="Click for Show More Result"
                                      >Show more</a
                                    >
                                  </p>
                                </div>
                                <ul class="list list-unstyled mb-0">
                                  <li
                                    class="
                                      list-custom-divider
                                      list-custom-divider-ERC20
                                      d-flex
                                      justify-content-between
                                      align-items-center
                                      font-size-1
                                      rounded-sm
                                      py-1
                                      px-2
                                      mb-1
                                    "
                                  >
                                    <span
                                      ><i
                                        class="fa fa-angle-right text-secondary"
                                      ></i
                                      ><strong> PRC-20 Tokens</strong> ({{
                                        tokenList_copy.length
                                      }})</span
                                    ><button
                                      type="button"
                                      class="
                                        btn
                                        sort
                                        text-secondary
                                        font-size-1
                                        p-0
                                      "
                                      id="btn_ERC20_sort"
                                      data-toggle="tooltip"
                                      title=""
                                      data-original-title="Click to sort"
                                    >
                                      &nbsp;&nbsp;<i
                                        class="fad fa-sort-down"
                                      ></i
                                      >&nbsp;&nbsp;
                                    </button>
                                  </li>
                                  <el-scrollbar style="height: 200px">
                                    <li
                                      class="list-custom list-custom-ERC20"
                                      v-for="(item, index) in tokenList_copy"
                                      :key="index"
                                    >
                                      <a
                                        class="
                                          link-hover
                                          d-flex
                                          justify-content-between
                                          align-items-center
                                        "
                                        href="javascript:;"
                                        style="cursor: auto"
                                        ><div>
                                          <div
                                            class="d-flex align-items-center"
                                          >
                                            <img
                                              :src="item.pic"
                                              width="12"
                                              class="mr-1 mCS_img_loaded"
                                            /><span
                                              class="
                                                list-name
                                                hash-tag
                                                text-truncate
                                              "
                                              >{{ item.name }}</span
                                            >
                                          </div>
                                          <span
                                            class="
                                              list-amount
                                              link-hover__item
                                              hash-tag hash-tag--md
                                              text-truncate
                                            "
                                            >{{
                                              decimal(
                                                item.balance,
                                                item.decimal
                                              )
                                            }}
                                            {{ item.name }}</span
                                          >
                                        </div>
                                      </a>
                                    </li>
                                  </el-scrollbar>
                                </ul>
                              </div>
                            </div>
                            <!-- <div
                              id="mCSB_1_scrollbar_vertical"
                              class="
                                mCSB_scrollTools mCSB_1_scrollbar
                                mCS-minimal-dark
                                mCSB_scrollTools_vertical
                              "
                              style="display: block"
                            >
                              <div class="mCSB_draggerContainer">
                                <div
                                  id="mCSB_1_dragger_vertical"
                                  class="mCSB_dragger"
                                  style="
                                    position: absolute;
                                    min-height: 50px;
                                    top: 0px;
                                    display: block;
                                    height: 13px;
                                    max-height: 246px;
                                  "
                                >
                                  <div
                                    class="mCSB_dragger_bar"
                                    style="line-height: 50px"
                                  ></div>
                                  <div class="mCSB_draggerRail"></div>
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body" v-if="prc_decimal != ''">
                  <div class="row align-items-center">
                    <div class="col-md-4 mb-1 mb-md-0">Name:</div>
                    <div class="col-md-8">{{ prc_name }}</div>
                  </div>

                  <hr class="hr-space" />

                  <div class="row align-items-center">
                    <div class="col-md-4 mb-1 mb-md-0">Decimal:</div>
                    <div class="col-md-8">{{ prc_decimal }}</div>
                  </div>
                  <hr class="hr-space" />

                  <div class="row align-items-center">
                    <div class="col-md-4 mb-1 mb-md-0" v-if="isUSDT">
                      Max Total Supply:
                    </div>
                    <div class="col-md-4 mb-1 mb-md-0" v-else>
                      Total Supply:
                    </div>
                    <div class="col-md-8">
                      {{ prc_total_supply | formatNum }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="ContentPlaceHolder1_cardright" class="col-md-6">
              <div class="card h-100">
                <div
                  class="
                    card-header
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <div id="ContentPlaceHolder1_td_misc" class="d-flex">
                    <h2 class="card-header-title mr-1">More Info</h2>
                  </div>

                  <div class="d-flex" v-if="is_prc20 == '1'">
                    <div
                      id="ContentPlaceHolder1_moreoptionsdiv"
                      class="position-relative"
                    >
                      <a
                        id="dropdownToolsInvoker-1"
                        class="btn btn-xs btn-xs--text btn-soft-secondary"
                        href="javascript:;"
                        role="button"
                        aria-controls="dropdownTools-1"
                        aria-haspopup="true"
                        aria-expanded="true"
                        data-unfold-event="click"
                        data-unfold-target="#dropdownTools-1"
                        data-unfold-type="css-animation"
                        data-unfold-duration="300"
                        data-unfold-delay="300"
                        data-unfold-hide-on-scroll="false"
                        data-unfold-animation-in="slideInUp"
                        data-unfold-animation-out="fadeOut"
                        @click="showUpdateInfo"
                      >
                        More <i class="fa fa-chevron-down small"></i>
                      </a>
                      <div
                        id="dropdownTools-1"
                        class="
                          dropdown-menu dropdown-menu-right dropdown-unfold
                          u-unfold--css-animation
                        "
                        :class="{
                          slideInUp: isSlideUp,
                          'u-unfold--hidden': isHidden,
                        }"
                        aria-labelledby="dropdownToolsInvoker-1"
                        style="animation-duration: 300ms"
                      >
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          @click="toVerifyAddress"
                          >Update Token Info</a
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body" v-if="creator != ''">
                  <div class="row">
                    <div class="col-md-4 mb-1 mb-md-0">
                      <span class="d-md-none d-lg-inline-block mr-1"
                        >Contract</span
                      >Creator:
                    </div>
                    <div class="col-md-8" v-if="creator != ''">
                      <a
                        :href="'/txs?address=' + creator"
                        class="hash-tag text-truncate"
                        data-toggle="tooltip"
                        title="Creator Address"
                        >{{ creator }}</a
                      ><span>
                        at txn
                        <a
                          :href="'/tx/' + tx_hash"
                          data-toggle="tooltip"
                          title="Creator Txn Hash"
                          class="hash-tag text-truncate"
                          >{{ tx_hash }}</a
                        ></span
                      >
                    </div>
                  </div>
                  <hr class="hr-space" />
                </div>
              </div>
            </div>
          </div>

          <span id="ContentPlaceHolder1_lblAdResult"></span>
          <div id="ContentPlaceHolder1_mainrow" class="card">
            <div
              class="
                card-header
                d-flex
                justify-content-between
                align-items-center
                p-0
              "
              v-if="isShowAddress"
            >
              <ul
                class="nav nav-custom nav-borderless nav_tabs1"
                id="nav_tabs"
                role="tablist"
              >
                <li
                  id="ContentPlaceHolder1_li_transactions"
                  class="nav-item"
                  ref="li_transations"
                >
                  <a
                    class="nav-link"
                    href="#transactions"
                    data-title="Primary Transactions"
                    data-toggle="tab"
                    @click="click_tab(1)"
                    :class="{ active: li1_active }"
                    ><span v-if="is_prc20 == '1'">Transfers</span>
                    <span v-if="is_prc20 == '0'">Transactions</span></a
                  >
                </li>

                <li
                  id="ContentPlaceHolder1_li_tokentransfers"
                  class="nav-item"
                  v-if="is_prc20 == '0'"
                  ref="li_transfers"
                >
                  <a
                    class="nav-link"
                    href="#tokentxns"
                    data-toggle="tab"
                    :class="{ active: li2_active }"
                    @click="
                      click_tab(2);
                      get_prc20_list();
                    "
                    >Prc20 Token Txns</a
                  >
                </li>
                <li
                  id="ContentPlaceHolder1_li_contracts"
                  class="nav-item"
                  ref="li_contracts"
                  v-if="false"
                >
                  <a
                    class="nav-link"
                    href="#contracts"
                    data-toggle="tab"
                    @click="click_tab(3)"
                    :class="{ active: li3_active }"
                    ><span>Contract</span>
                    <!-- ifContract -->
                  </a>
                </li>
                <li
                  id="ContentPlaceHolder1_li_tokentransfers"
                  class="nav-item"
                  v-if="isholders"
                  ref="li_transfers"
                >
                  <a
                    class="nav-link"
                    href="#holders"
                    data-toggle="tab"
                    :class="{ active: li4_active }"
                    @click="click_tab(4)"
                    >Holders</a
                  >
                </li>
              </ul>
            </div>
            <div class="card-body">
              <div class="tab-content">
                <div
                  class="tab-pane fade active show"
                  id="transactions"
                  role="tabpanel"
                  aria-labelledby="transactions-tab"
                >
                  <div
                    class="
                      d-flex
                      flex-wrap flex-xl-nowrap
                      text-nowrap
                      align-items-center
                      ml-auto
                    "
                  ></div>
                  <div
                    id="ContentPlaceHolder1_topPageDiv"
                    class="d-md-flex justify-content-between mb-4"
                  >
                    <p class="mb-2 mb-md-0">
                      <span class="d-flex align-items-center">
                        <i
                          id="spinwheel"
                          class="fa fa-spin fa-spinner fa-1x fa-pulse mr-1"
                          style="display: none"
                        ></i>
                        A total of {{ totalTxs }} transactions found
                      </span>
                      <!-- <span v-show="addr != undefined"
                        >account address: {{ addr }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <span v-show="addr != undefined"
                        >account balance: {{ balance }}</span
                      > -->
                    </p>

                    <nav aria-label="page navigation">
                      <ul class="pagination pagination-sm mb-0">
                        <li
                          class="page-item"
                          :class="{ disabled: page == 0 || !clickFlag }"
                        >
                          <span
                            class="page-link"
                            @click="
                              page = 0;
                              changePage();
                            "
                            >First</span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{ disabled: page == 0 || !clickFlag }"
                        >
                          <span
                            @click="
                              page = page - 1;
                              changePage();
                            "
                            class="page-link"
                            ><i class="fa fa-chevron-left small"></i></span
                          ><span class="sr-only">Previous</span>
                        </li>
                        <li class="page-item">
                          <span class="page-link text-nowrap"
                            >Page
                            <strong class="font-weight-medium">{{
                              page + 1
                            }}</strong>
                            of
                            <strong class="font-weight-medium">{{
                              allPages
                            }}</strong></span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{
                            disabled: page + 1 == allPages || !clickFlag,
                          }"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Go to Next"
                        >
                          <span
                            class="page-link"
                            @click="
                              page = page + 1;
                              changePage();
                            "
                            aria-label="Next"
                            ><span aria-hidden="True"
                              ><i class="fa fa-chevron-right small"></i
                            ></span>
                            <span class="sr-only">Next</span></span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{
                            disabled: page + 1 == allPages || !clickFlag,
                          }"
                        >
                          <span
                            @click="
                              page = allPages - 1;
                              changePage();
                            "
                            class="page-link"
                            ><span aria-hidden="True">Last</span>
                            <span class="sr-only">Last</span></span
                          >
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="table-responsive mb-2 mb-md-0" id="paywall_mask">
                    <table class="table table-hover">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" width="1">Txn Hash</th>
                          <!-- <th scope="col" width="1">
                        Method
                        <i
                          class="fal fa-info-circle"
                          data-toggle="tooltip"
                          data-html="true"
                          data-boundary="viewport"
                          title=""
                          data-original-title="Function executed based on decoded input data. For unidentified functions, method ID is displayed instead."
                        ></i>
                      </th> -->
                          <th
                            scope="col"
                            width="1"
                            class="d-none d-sm-table-cell"
                          >
                            <div class="d-flex align-items-center">
                              <div class="mr-2">Block</div>
                            </div>
                          </th>
                          <th scope="col">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">Age</div>
                            </div>
                          </th>
                          <th scope="col">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">From</div>
                            </div>
                          </th>
                          <th
                            scope="col"
                            width="30"
                            style="min-width: 160px"
                          ></th>
                          <th scope="col" style="min-width: 250px">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">To</div>
                            </div>
                          </th>
                          <th scope="col" style="min-width: 130px">Value</th>
                          <th scope="col">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">Txn Fee</div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in txList" :key="index">
                          <td>
                            <span class="hash-tag text-truncate"
                              ><a
                                :href="
                                  '/tx/' + item.hash + '/' + item.block_height
                                "
                                class="myFnExpandBox_searchVal"
                                >{{ item.hash }}</a
                              ></span
                            >
                          </td>
                          <!-- <td>
                        <span
                          style="min-width: 68px"
                          class="
                            u-label u-label--xs u-label--info
                            rounded
                            text-dark text-center
                          "
                          data-toggle="tooltip"
                          data-boundary="viewport"
                          data-html="true"
                          title=""
                          data-original-title="Atomic Match_"
                          >Atomic Match_</span
                        >
                      </td> -->
                          <td class="d-none d-sm-table-cell">
                            <a :href="'/blocksdetail/' + item.block_height">{{
                              item.block_height
                            }}</a>
                          </td>
                          <td class="showDate" style="display: none !important">
                            <span
                              rel="tooltip"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title=""
                            ></span>
                          </td>
                          <td style="" class="showAge">
                            <span
                              rel="tooltip"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title=""
                              >{{ item.created_at | timeFromat }}</span
                            >
                          </td>
                          <td>
                            <span
                              class="hash-tag text-truncate"
                              data-toggle="tooltip"
                              data-boundary="viewport"
                              data-html="true"
                              :title="item.from"
                              data-original-title=""
                              v-if="addr != item.from"
                            >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '1'"
                                ></i></el-tooltip
                              ><a :href="'/txs?address=' + item.from">{{
                                item.code != null && item.code == item.from
                                  ? item.from
                                  : item.from
                              }}</a></span
                            >
                            <span
                              class="hash-tag text-truncate"
                              v-if="addr == item.from"
                            >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '1'"
                                ></i></el-tooltip
                              >{{
                                item.code != null && item.code == item.from
                                  ? item.from
                                  : item.from
                              }}</span
                            >
                          </td>
                          <td class="text-center">
                            <span
                              class="
                                btn btn-xs btn-icon btn-soft-success
                                rounded-circle
                              "
                              ><i
                                class="fas fa-long-arrow-right btn-icon__inner"
                              ></i
                            ></span>
                          </td>
                          <td>
                            <!-- item.code_name -->
                            <span
                              style="white-space: nowrap"
                              v-if="addr != item.to"
                            >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '2'"
                                ></i
                              ></el-tooltip>
                              <a
                                class="hash-tag text-truncate"
                                :href="'/txs?address=' + item.to"
                                data-toggle="tooltip"
                                data-boundary="viewport"
                                data-html="true"
                                :title="item.to"
                                data-original-title=""
                                >{{
                                  item.code != null && item.code == item.to
                                    ? item.to
                                    : item.to
                                }}</a
                              ></span
                            >
                            <!-- <i
                              class="far fa-file-text-o text-secondary"
                              data-toggle="tooltip"
                              data-boundary="viewport"
                              data-html="true"
                              title=""
                              data-original-title="Contract"
                            ></i> -->

                            <span
                              class="hash-tag text-truncate"
                              v-if="addr == item.to"
                              ><el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '2'"
                                ></i></el-tooltip
                              >{{
                                item.code != null && item.code == item.to
                                  ? item.to
                                  : item.to
                              }}</span
                            >
                          </td>
                          <td>
                            {{
                              item.amount
                                | fromWei
                                | scientificNotationToString
                                | decimalNew
                            }}
                          </td>
                          <td style="" class="showTxnFee">
                            <span class="small text-secondary">0.00</span>
                          </td>
                          <td
                            style="display: none !important"
                            class="showGasPrice"
                          >
                            <span class="small text-secondary">65</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    id="signInPopUp"
                    class="row justify-content-center align-items-center"
                    style="display: none"
                  >
                    <div class="col d-none d-lg-block">
                      <img
                        class="img-fluid mx-4"
                        src="../assets/images/svg/bg/bg1-left-side.svg?v=20.4.3.0"
                        alt=""
                      />
                    </div>
                    <div class="col-10 col-sm-8 col-lg-7 col-xl-5">
                      <div class="text-center py-5 my-5-alt">
                        <h4 class="font-weight-bold">
                          Sign In for Continued Access
                        </h4>
                        <p class="h5 text-secondary mb-4">
                          No worries, it's absolutely <strong>free</strong> and
                          takes a minute!
                          <br class="-none d-md-inline-block" />
                          Register a
                          <a class="text-primary" href="/register"
                            >Free Account</a
                          >
                          today.
                        </p>
                        <div class="mb-3"></div>
                      </div>
                    </div>
                    <div class="col d-none d-lg-block">
                      <img
                        class="img-fluid mx-4"
                        src="../assets/images/svg/bg/bg1-right-side.svg?v=20.4.3.0"
                        alt=""
                      />
                    </div>
                  </div>
                  <div id="ContentPlaceHolder1_pageRecords">
                    <form
                      method="post"
                      action="./txs?block=13085066"
                      id="ctl00"
                    >
                      <div class="aspNetHidden">
                        <input
                          type="hidden"
                          name="__EVENTTARGET"
                          id="__EVENTTARGET"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__EVENTARGUMENT"
                          id="__EVENTARGUMENT"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__LASTFOCUS"
                          id="__LASTFOCUS"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__VIEWSTATE"
                          id="__VIEWSTATE"
                          value="xqABbyVuV6MaSdognYdteKXGMRazc0ooDVyZEbMvHuw1UCGIabHJ6GBKjtr4Hrd2/EsPjeCVTfAgPnKr+a755Qx0wqvCy2+81UfxIUB+3ZE="
                        />
                      </div>

                      <div class="aspNetHidden">
                        <input
                          type="hidden"
                          name="__VIEWSTATEGENERATOR"
                          id="__VIEWSTATEGENERATOR"
                          value="FCB51872"
                        />
                        <input
                          type="hidden"
                          name="__EVENTVALIDATION"
                          id="__EVENTVALIDATION"
                          value="PkOLupSnqdb+BX7szq7Ax3jWBMMjdyt0rEXbLfZjVZiJhkXRSAIto2svc7OrQ753SJvb+Wgw6DBz7wATxUAjoDwlbRBD+ZplCP8DkjGiqoL8q7CbAk68BeiAPzKct3MQVnOkt4k60ddplbGoS8XGfq60DeiCXfm2fC/bBLPGeM9I6idyEBfVFrBAjNyKBQddynGVKIkuH6KOc6vWcPQHIQ=="
                        />
                      </div>
                      <div class="d-md-flex justify-content-between my-3">
                        <div
                          class="
                            d-flex
                            align-items-center
                            text-secondary
                            mb-2 mb-md-0
                          "
                        >
                          Show
                          <select
                            name="ctl00$ContentPlaceHolder1$ddlRecordsPerPage"
                            v-model="per_page"
                            @change="changePerPage"
                            id="ContentPlaceHolder1_ddlRecordsPerPage"
                            class="custom-select custom-select-xs mx-2"
                          >
                            <option value="10">10</option>
                            <option selected="selected" value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          Records
                        </div>
                        <nav aria-label="page navigation">
                          <ul class="pagination pagination-sm mb-0">
                            <li
                              class="page-item"
                              :class="{ disabled: page == 0 || !clickFlag }"
                            >
                              <span
                                class="page-link"
                                @click="
                                  page = 0;
                                  changePage();
                                "
                                >First</span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{ disabled: page == 0 || !clickFlag }"
                            >
                              <span
                                @click="
                                  page = page - 1;
                                  changePage();
                                "
                                class="page-link"
                                ><i class="fa fa-chevron-left small"></i></span
                              ><span class="sr-only">Previous</span>
                            </li>
                            <li class="page-item">
                              <span class="page-link text-nowrap"
                                >Page
                                <strong class="font-weight-medium">{{
                                  page + 1
                                }}</strong>
                                of
                                <strong class="font-weight-medium">{{
                                  allPages
                                }}</strong></span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled: page + 1 == allPages || !clickFlag,
                              }"
                              data-toggle="tooltip"
                              title=""
                              data-original-title="Go to Next"
                            >
                              <span
                                class="page-link"
                                @click="
                                  page = page + 1;
                                  changePage();
                                "
                                aria-label="Next"
                                ><span aria-hidden="True"
                                  ><i class="fa fa-chevron-right small"></i
                                ></span>
                                <span class="sr-only">Next</span></span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled: page + 1 == allPages || !clickFlag,
                              }"
                            >
                              <span
                                @click="
                                  page = allPages - 1;
                                  changePage();
                                "
                                class="page-link"
                                ><span aria-hidden="True">Last</span>
                                <span class="sr-only">Last</span></span
                              >
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </form>
                  </div>
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      mt-3
                      mb-4
                    "
                  >
                    <div class="d-flex align-items-center text-secondary"></div>
                    <div class="small text-muted"></div>
                  </div>
                </div>
                <div class="tab-pane fade show" id="tokentxns">
                  <div
                    class="
                      d-flex
                      flex-wrap flex-xl-nowrap
                      text-nowrap
                      align-items-center
                      ml-auto
                    "
                  ></div>
                  <div class="pl-2 pr-3 js-focus-state">
                    <input
                      type="text"
                      placeholder="Search By Token Address"
                      aria-label="Search for Token name"
                      aria-describedby="filter-search"
                      class="form-control form-control-xs search mb-3"
                      v-model="token_address"
                      @keyup.enter.prevent="searchTxns($event)"
                    />
                  </div>
                  <div
                    id="ContentPlaceHolder1_topPageDiv"
                    class="d-md-flex justify-content-between mb-4"
                  >
                    <p class="mb-2 mb-md-0">
                      <span class="d-flex align-items-center">
                        <i
                          id="spinwheel"
                          class="fa fa-spin fa-spinner fa-1x fa-pulse mr-1"
                          style="display: none"
                        ></i>
                        A total of {{ prc20_totalTxs }} transactions found
                      </span>
                      <!-- <span v-show="addr != undefined"
                        >account address: {{ addr }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <span v-show="addr != undefined"
                        >account balance: {{ balance }}</span
                      > -->
                    </p>

                    <nav aria-label="page navigation">
                      <ul class="pagination pagination-sm mb-0">
                        <li
                          class="page-item"
                          :class="{ disabled: page_prc == 0 || !clickFlag }"
                        >
                          <span
                            class="page-link"
                            @click="
                              page_prc = 0;
                              changePagePrc();
                            "
                            >First</span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{ disabled: page_prc == 0 || !clickFlag }"
                        >
                          <span
                            @click="
                              page_prc = page_prc - 1;
                              changePagePrc();
                            "
                            class="page-link"
                            ><i class="fa fa-chevron-left small"></i></span
                          ><span class="sr-only">Previous</span>
                        </li>
                        <li class="page-item">
                          <span class="page-link text-nowrap"
                            >Page
                            <strong class="font-weight-medium">{{
                              page_prc + 1
                            }}</strong>
                            of
                            <strong class="font-weight-medium">{{
                              prc20_allPages
                            }}</strong></span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{
                            disabled:
                              page_prc + 1 == prc20_allPages || !clickFlag,
                          }"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Go to Next"
                        >
                          <span
                            class="page-link"
                            @click="
                              page_prc = page_prc + 1;
                              changePagePrc();
                            "
                            aria-label="Next"
                            ><span aria-hidden="True"
                              ><i class="fa fa-chevron-right small"></i
                            ></span>
                            <span class="sr-only">Next</span></span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{
                            disabled:
                              page_prc + 1 == prc20_allPages || !clickFlag,
                          }"
                        >
                          <span
                            @click="
                              page_prc = prc20_allPages - 1;
                              changePagePrc();
                            "
                            class="page-link"
                            ><span aria-hidden="True">Last</span>
                            <span class="sr-only">Last</span></span
                          >
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="table-responsive mb-2 mb-md-0" id="paywall_mask">
                    <table class="table table-hover">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" width="1">Txn Hash</th>
                          <th
                            scope="col"
                            width="1"
                            class="d-none d-sm-table-cell"
                          >
                            <div class="d-flex align-items-center">
                              <div class="mr-2">Block</div>
                            </div>
                          </th>
                          <th scope="col">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">Age</div>
                            </div>
                          </th>
                          <th scope="col">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">From</div>
                            </div>
                          </th>
                          <th
                            scope="col"
                            width="30"
                            style="min-width: 160px"
                          ></th>
                          <th scope="col" style="min-width: 250px">
                            <div class="d-flex align-items-center">
                              <div class="mr-2">To</div>
                            </div>
                          </th>
                          <th scope="col" style="min-width: 130px">Value</th>
                          <th scope="col">Token</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in prc20_list" :key="index">
                          <td>
                            <span class="hash-tag text-truncate"
                              ><a
                                :href="
                                  '/tx/' + item.hash + '/' + item.block_height
                                "
                                class="myFnExpandBox_searchVal"
                                >{{ item.hash }}</a
                              ></span
                            >
                          </td>
                          <!-- <td>
                        <span
                          style="min-width: 68px"
                          class="
                            u-label u-label--xs u-label--info
                            rounded
                            text-dark text-center
                          "
                          data-toggle="tooltip"
                          data-boundary="viewport"
                          data-html="true"
                          title=""
                          data-original-title="Atomic Match_"
                          >Atomic Match_</span
                        >
                      </td> -->
                          <td class="d-none d-sm-table-cell">
                            <a :href="'/blocksdetail/' + item.block_height">{{
                              item.block_height
                            }}</a>
                          </td>
                          <td class="showDate" style="display: none !important">
                            <span
                              rel="tooltip"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title=""
                            ></span>
                          </td>
                          <td style="" class="showAge">
                            <span
                              rel="tooltip"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title=""
                              >{{ item.created_at | timeFromat }}</span
                            >
                          </td>
                          <td>
                            <span
                              class="hash-tag text-truncate"
                              data-toggle="tooltip"
                              data-boundary="viewport"
                              data-html="true"
                              :title="item.from"
                              data-original-title="0x5f08247207dc930004f0a00372c12af55c32ca42"
                              v-if="addr != item.from"
                            >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '1'"
                                ></i></el-tooltip
                              ><a :href="'/txs?address=' + item.from">{{
                                item.code != null && item.code == item.from
                                  ? item.from
                                  : item.from
                              }}</a></span
                            >
                            <span
                              class="hash-tag text-truncate"
                              v-if="addr == item.from"
                            >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '1'"
                                ></i></el-tooltip
                              >{{
                                item.code != null && item.code == item.from
                                  ? item.from
                                  : item.from
                              }}</span
                            >
                          </td>
                          <td class="text-center">
                            <span
                              class="
                                btn btn-xs btn-icon btn-soft-success
                                rounded-circle
                              "
                              ><i
                                class="fas fa-long-arrow-right btn-icon__inner"
                              ></i
                            ></span>
                          </td>
                          <td>
                            <span
                              style="white-space: nowrap"
                              v-if="addr != item.to"
                            >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '2'"
                                ></i
                              ></el-tooltip>
                              <a
                                class="hash-tag text-truncate"
                                :href="'/txs?address=' + item.to"
                                data-toggle="tooltip"
                                data-boundary="viewport"
                                data-html="true"
                                :title="item.to"
                                data-original-title=""
                                >{{
                                  item.code != null && item.code == item.to
                                    ? item.to
                                    : item.to
                                }}</a
                              ></span
                            >
                            <span
                              class="hash-tag text-truncate"
                              v-if="addr == item.to"
                              ><el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.kind == '3' || item.kind == '2'"
                                ></i></el-tooltip
                              >{{
                                item.code != null && item.code == item.to
                                  ? item.to
                                  : item.to
                              }}</span
                            >
                          </td>
                          <td>
                            {{
                              item.value == null
                                ? "0"
                                : decimal(item.value, item.decimal)
                            }}
                          </td>
                          <td>
                            <a :href="'/txs?address=' + item.code">
                              <span data-toggle="tooltip" title="Wrapped Ether">
                                <font color="">{{ item.code_name }}</font>
                              </span>
                              ({{ item.code }})</a
                            >
                            <!-- {{ item.code_name }} ({{ item.code }}) -->
                          </td>
                          <td
                            style="display: none !important"
                            class="showGasPrice"
                          >
                            <span class="small text-secondary">65</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    id="signInPopUp"
                    class="row justify-content-center align-items-center"
                    style="display: none"
                  >
                    <div class="col d-none d-lg-block">
                      <img
                        class="img-fluid mx-4"
                        src="../assets/images/svg/bg/bg1-left-side.svg?v=20.4.3.0"
                        alt=""
                      />
                    </div>
                    <div class="col-10 col-sm-8 col-lg-7 col-xl-5">
                      <div class="text-center py-5 my-5-alt">
                        <h4 class="font-weight-bold">
                          Sign In for Continued Access
                        </h4>
                        <p class="h5 text-secondary mb-4">
                          No worries, it's absolutely
                          <strong>free</strong> and takes a minute!
                          <br class="-none d-md-inline-block" />
                          Register a
                          <a class="text-primary" href="/register"
                            >Free Account</a
                          >
                          today.
                        </p>
                        <div class="mb-3"></div>
                      </div>
                    </div>
                    <div class="col d-none d-lg-block">
                      <img
                        class="img-fluid mx-4"
                        src="../assets/images/svg/bg/bg1-right-side.svg?v=20.4.3.0"
                        alt=""
                      />
                    </div>
                  </div>
                  <div id="ContentPlaceHolder1_pageRecords">
                    <form
                      method="post"
                      action="./txs?block=13085066"
                      id="ctl00"
                    >
                      <div class="aspNetHidden">
                        <input
                          type="hidden"
                          name="__EVENTTARGET"
                          id="__EVENTTARGET"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__EVENTARGUMENT"
                          id="__EVENTARGUMENT"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__LASTFOCUS"
                          id="__LASTFOCUS"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__VIEWSTATE"
                          id="__VIEWSTATE"
                          value="xqABbyVuV6MaSdognYdteKXGMRazc0ooDVyZEbMvHuw1UCGIabHJ6GBKjtr4Hrd2/EsPjeCVTfAgPnKr+a755Qx0wqvCy2+81UfxIUB+3ZE="
                        />
                      </div>

                      <div class="aspNetHidden">
                        <input
                          type="hidden"
                          name="__VIEWSTATEGENERATOR"
                          id="__VIEWSTATEGENERATOR"
                          value="FCB51872"
                        />
                        <input
                          type="hidden"
                          name="__EVENTVALIDATION"
                          id="__EVENTVALIDATION"
                          value="PkOLupSnqdb+BX7szq7Ax3jWBMMjdyt0rEXbLfZjVZiJhkXRSAIto2svc7OrQ753SJvb+Wgw6DBz7wATxUAjoDwlbRBD+ZplCP8DkjGiqoL8q7CbAk68BeiAPzKct3MQVnOkt4k60ddplbGoS8XGfq60DeiCXfm2fC/bBLPGeM9I6idyEBfVFrBAjNyKBQddynGVKIkuH6KOc6vWcPQHIQ=="
                        />
                      </div>
                      <div class="d-md-flex justify-content-between my-3">
                        <div
                          class="
                            d-flex
                            align-items-center
                            text-secondary
                            mb-2 mb-md-0
                          "
                        >
                          Show
                          <select
                            name="ctl00$ContentPlaceHolder1$ddlRecordsPerPage"
                            v-model="per_page_prc"
                            @change="changePerPagePrc"
                            id="ContentPlaceHolder1_ddlRecordsPerPage"
                            class="custom-select custom-select-xs mx-2"
                          >
                            <option value="10">10</option>
                            <option selected="selected" value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          Records
                        </div>
                        <nav aria-label="page navigation">
                          <ul class="pagination pagination-sm mb-0">
                            <li
                              class="page-item"
                              :class="{ disabled: page_prc == 0 || !clickFlag }"
                            >
                              <span
                                class="page-link"
                                @click="
                                  page_prc = 0;
                                  changePagePrc();
                                "
                                >First</span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{ disabled: page_prc == 0 || !clickFlag }"
                            >
                              <span
                                @click="
                                  page_prc = page_prc - 1;
                                  changePagePrc();
                                "
                                class="page-link"
                                ><i class="fa fa-chevron-left small"></i></span
                              ><span class="sr-only">Previous</span>
                            </li>
                            <li class="page-item">
                              <span class="page-link text-nowrap"
                                >Page
                                <strong class="font-weight-medium">{{
                                  page_prc + 1
                                }}</strong>
                                of
                                <strong class="font-weight-medium">{{
                                  prc20_allPages
                                }}</strong></span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled:
                                  page_prc + 1 == prc20_allPages || !clickFlag,
                              }"
                              data-toggle="tooltip"
                              title=""
                              data-original-title="Go to Next"
                            >
                              <span
                                class="page-link"
                                @click="
                                  page_prc = page_prc + 1;
                                  changePagePrc();
                                "
                                aria-label="Next"
                                ><span aria-hidden="True"
                                  ><i class="fa fa-chevron-right small"></i
                                ></span>
                                <span class="sr-only">Next</span></span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled:
                                  page_prc + 1 == prc20_allPages || !clickFlag,
                              }"
                            >
                              <span
                                @click="
                                  page_prc = prc20_allPages - 1;
                                  changePagePrc();
                                "
                                class="page-link"
                                ><span aria-hidden="True">Last</span>
                                <span class="sr-only">Last</span></span
                              >
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </form>
                  </div>
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      mt-3
                      mb-4
                    "
                  >
                    <div class="d-flex align-items-center text-secondary"></div>
                    <div class="small text-muted"></div>
                  </div>
                </div>
                <div
                  class="tab-pane fade show"
                  id="contracts"
                  style="min-height: 500px"
                >
                  <div
                    class="
                      d-md-flex
                      justify-content-between
                      align-items-center
                      sticky-top
                      bg-white-content
                      py-1
                      mb-3
                    "
                  >
                    <ul
                      class="nav nav-pills nav-pills-secondary mb-3"
                      id="nav_subtabs"
                      role="tablist"
                      style="display: none"
                    >
                      <li
                        id="ContentPlaceHolder1_li_code"
                        class="nav-item"
                        onclick="javascript:updatehash('code');"
                      >
                        <a
                          class="nav-link active show"
                          href="#code"
                          data-toggle="tab"
                          onclick="javascript:updatehash('code');"
                          >Code</a
                        >
                      </li>
                    </ul>
                    <div id="divClientMultiSearch" style="display: block"></div>
                  </div>
                  <div
                    class="tab-pane fade active show"
                    id="code"
                    style="display: visible"
                  >
                    <div v-if="!ifVeri">
                      <span class="mb-3"
                        ><span class="h5 mb-0"
                          ><i class="fa fa-info-circle text-secondary"></i
                        ></span>
                        Are you the contract creator?
                        <a href="javascript:;" @click="toVerify"
                          ><b>Verify and Publish</b></a
                        >
                        your contract source code today!<br /><br
                      /></span>

                      <!-- <div id="dividcode">
                        <pre class="wordwrap" style="height: 15pc"></pre>
                      </div> -->
                    </div>
                    <div v-if="ifVeri">
                      <div id="ContentPlaceHolder1_contractCodeDiv">
                        <div class="row py-1">
                          <div class="col-md-12">
                            <h3 class="h6 text-dark font-weight-bold mb-4">
                              <i class="fa fa-check-circle text-success"></i>
                              <strong
                                >Contract Source Code Verified
                                <span class="font-weight-normal text-secondary"
                                  >(Exact Match)</span
                                ></strong
                              >
                              <span
                                id="ContentPlaceHolder1_spanCompilerWarning"
                                class="d-none d-sm-block"
                                style="
                                  position: absolute;
                                  right: 8px;
                                  margin-top: -22px;
                                "
                              >
                                <a
                                  data-toggle="modal"
                                  data-target="#myModalCompilerWarning"
                                  rel="tooltip"
                                  title=""
                                  href="#"
                                  data-original-title="Solidity Compiler Bugs, click for more info"
                                  ><i
                                    class="
                                      fa fa-exclamation-triangle
                                      text-warning
                                      mr-2
                                    "
                                    style="font-size: 22px"
                                  ></i
                                ></a>
                              </span>
                            </h3>
                          </div>
                        </div>
                        <div class="row mx-gutters-lg-1 mb-5">
                          <div class="col-md-6">
                            <div class="row align-items-center">
                              <div class="col-5 col-lg-4 mb-1 mb-md-0">
                                Contract Name:
                              </div>
                              <div class="col-7 col-lg-8">
                                <span class="h6 font-weight-bold mb-0">{{
                                  contractname
                                }}</span>
                              </div>
                            </div>
                            <hr class="hr-space" />
                            <div class="row">
                              <div class="col-5 col-lg-4 mb-1 mb-md-0">
                                Compiler Version
                              </div>
                              <div class="col-7 col-lg-8">
                                <span class="h6 font-weight-bold mb-0"
                                  >v0.8.0+commit.c7dfd78e</span
                                >
                              </div>
                            </div>
                            <hr class="d-block d-md-none" />
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-5 col-lg-4 mb-1 mb-md-0">
                                Optimization Enabled:
                              </div>
                              <div class="col-7 col-lg-8">
                                <span class="h6 font-weight-bold mb-0"
                                  >No
                                  <span class="font-weight-normal">with</span>
                                  200
                                  <span class="font-weight-normal"
                                    >runs</span
                                  ></span
                                >
                              </div>
                            </div>
                            <hr class="hr-space" />
                            <div class="row">
                              <div class="col-5 col-lg-4 mb-1 mb-md-0">
                                Other Settings:
                              </div>
                              <div class="col-7 col-lg-8">
                                <span class="h6 font-weight-bold mb-0">
                                  <span class="font-weight-normal"
                                    >evmVersion {{ evmVersion }}</span
                                  >
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="mb-3"></span>
                      <div id="dividcode">
                        <div class="mb-4">
                          <div
                            class="
                              d-md-flex
                              justify-content-between
                              align-items-center
                              bg-white-content
                              py-2
                            "
                          >
                            <h4 class="card-header-title">
                              <i
                                class="far fa-file-code text-secondary mr-1"
                              ></i
                              >Contract Source Code
                              <span class="font-weight-normal text-secondary"
                                >(Solidity
                                <a
                                  rel="nofollow noopener"
                                  href="https://solidity.readthedocs.io/en/v0.5.8/using-the-compiler.html#compiler-input-and-output-json-description"
                                  data-toggle="tooltip"
                                  title=""
                                  target="blank"
                                  class="text-primary"
                                  data-original-title="Click to learn more"
                                  >Standard Json-Input</a
                                >
                                format)</span
                              >
                            </h4>
                          </div>
                          <br />
                          <div v-for="(item, index) in sourceList" :key="index">
                            <div class="d-flex justify-content-between">
                              <span class="text-secondary"
                                >File {{ index + 1 }} of
                                {{ sourceList.length }} :
                                {{ item.filename }}</span
                              >
                            </div>
                            <pre
                              class="
                                js-sourcecopyarea
                                editor
                                ace_editor ace-dawn
                              "
                              id="editor1"
                              style="margin-top: 5px; height: 350px"
                            >  <editor
                                  :options="editorOptions"
                                  v-model="item.content"
                                  @init="editorInit"
                                  lang="csharp"
                                  theme="chrome"
                     
                                >
                                </editor></pre>
                            <br />
                          </div>

                          <!-- <div class="d-flex justify-content-between">
                            <span class="text-secondary">Settings</span>
                          </div>
                          <pre
                            class="js-sourcecopyarea editor ace_editor ace-dawn"
                            id="editor"
                            style="margin-top: 5px; height: 266px"
                          ><textarea class="ace_text-input" wrap="off" autocorrect="off" autocapitalize="off" spellcheck="false" style="opacity: 0; height: 14px; width: 6.59781px; left: 149.967px; top: 28px;"></textarea><div class="ace_gutter"><div class="ace_layer ace_gutter-layer ace_folding-enabled" style="margin-top: 0px; height: 294px; width: 47px;"><div class="ace_gutter-cell " style="height: 14px;">1<span class="ace_fold-widget ace_start ace_open" style="height: 14px;"></span></div><div class="ace_gutter-cell " style="height: 14px;">2<span class="ace_fold-widget ace_start ace_open" style="height: 14px;"></span></div><div class="ace_gutter-cell " style="height: 14px;">3</div><div class="ace_gutter-cell " style="height: 14px;">4</div><div class="ace_gutter-cell " style="height: 14px;">5</div><div class="ace_gutter-cell " style="height: 14px;">6<span class="ace_fold-widget ace_start ace_open" style="height: 14px;"></span></div><div class="ace_gutter-cell " style="height: 14px;">7<span class="ace_fold-widget ace_start ace_open" style="height: 14px;"></span></div><div class="ace_gutter-cell " style="height: 14px;">8<span class="ace_fold-widget ace_start ace_open" style="height: 14px;"></span></div><div class="ace_gutter-cell " style="height: 14px;">9</div><div class="ace_gutter-cell " style="height: 14px;">10</div><div class="ace_gutter-cell " style="height: 14px;">11</div><div class="ace_gutter-cell " style="height: 14px;">12</div><div class="ace_gutter-cell " style="height: 14px;">13</div><div class="ace_gutter-cell " style="height: 14px;">14</div><div class="ace_gutter-cell " style="height: 14px;">15</div><div class="ace_gutter-cell " style="height: 14px;">16</div><div class="ace_gutter-cell " style="height: 14px;">17</div><div class="ace_gutter-cell " style="height: 14px;">18</div><div class="ace_gutter-cell " style="height: 14px;">19</div></div><div class="ace_gutter-active-line" style="top: 28px; height: 14px;"></div></div><div class="ace_scroller" style="left: 47px; right: 0px; bottom: 0px;"><div class="ace_content" style="margin-top: 0px; width: 1295px; height: 294px; margin-left: 0px;"><div class="ace_layer ace_print-margin-layer"><div class="ace_print-margin" style="left: 531.825px; visibility: hidden;"></div></div><div class="ace_layer ace_marker-layer"><div class="ace_active-line" style="height:14px;top:28px;left:0;right:0;"></div></div><div class="ace_layer ace_text-layer" style="padding: 0px 4px;"><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_paren ace_lparen">{</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">  <span class="ace_string ace_start">"</span><span class="ace_string">optimizer</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_paren ace_lparen">{</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">    <span class="ace_string ace_start">"</span><span class="ace_string">enabled</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_constant ace_language ace_boolean">false</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">    <span class="ace_string ace_start">"</span><span class="ace_string">runs</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_constant ace_numeric">200</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">  <span class="ace_paren ace_rparen">}</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">  <span class="ace_string ace_start">"</span><span class="ace_string">outputSelection</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_paren ace_lparen">{</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">    <span class="ace_string ace_start">"</span><span class="ace_string">*</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_paren ace_lparen">{</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>  <span class="ace_string ace_start">"</span><span class="ace_string">*</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_paren ace_lparen">[</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>    <span class="ace_string ace_start">"</span><span class="ace_string">evm.bytecode</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>    <span class="ace_string ace_start">"</span><span class="ace_string">evm.deployedBytecode</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>    <span class="ace_string ace_start">"</span><span class="ace_string">devdoc</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>    <span class="ace_string ace_start">"</span><span class="ace_string">userdoc</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>    <span class="ace_string ace_start">"</span><span class="ace_string">metadata</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>    <span class="ace_string ace_start">"</span><span class="ace_string">abi</span><span class="ace_string ace_end">"</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_indent-guide">    </span>  <span class="ace_paren ace_rparen">]</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">    <span class="ace_paren ace_rparen">}</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">  <span class="ace_paren ace_rparen">}</span><span class="ace_punctuation ace_operator">,</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px">  <span class="ace_string ace_start">"</span><span class="ace_string">libraries</span><span class="ace_string ace_end">"</span><span class="ace_punctuation ace_operator">:</span> <span class="ace_paren ace_lparen">{</span><span class="ace_paren ace_rparen">}</span></div></div><div class="ace_line_group" style="height:14px"><div class="ace_line" style="height:14px"><span class="ace_paren ace_rparen">}</span></div></div></div><div class="ace_layer ace_marker-layer"></div><div class="ace_layer ace_cursor-layer ace_hidden-cursors"><div class="ace_cursor" style="left: 102.967px; top: 28px; width: 6.59781px; height: 14px;"></div></div></div></div><div class="ace_scrollbar ace_scrollbar-v" style="display: none; width: 22px; bottom: 0px;"><div class="ace_scrollbar-inner" style="width: 22px; height: 266px;"></div></div><div class="ace_scrollbar ace_scrollbar-h" style="display: none; height: 22px; left: 47px; right: 0px;"><div class="ace_scrollbar-inner" style="height: 22px; width: 1295px;"></div></div><div style="height: auto; width: auto; top: 0px; left: 0px; visibility: hidden; position: absolute; white-space: pre; font: inherit; overflow: hidden;"><div style="height: auto; width: auto; top: 0px; left: 0px; visibility: hidden; position: absolute; white-space: pre; font: inherit; overflow: visible;"></div><div style="height: auto; width: auto; top: 0px; left: 0px; visibility: hidden; position: absolute; white-space: pre; font-style: inherit; font-variant: inherit; font-stretch: inherit; font-size: inherit; line-height: inherit; font-family: inherit; overflow: visible;">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div></div></pre>
                          <br /> -->
                        </div>
                        <div class="mb-4">
                          <div
                            class="
                              d-md-flex
                              justify-content-between
                              align-items-center
                              bg-white-content
                              py-2
                            "
                          >
                            <h4 class="card-header-title">
                              <i class="fa fa-tasks text-secondary mr-1"></i
                              >Contract ABI
                            </h4>
                          </div>
                          <pre
                            class="wordwrap js-copytextarea2"
                            id="js-copytextarea2"
                            style="
                              height: 200px;
                              max-height: 400px;
                              margin-top: 5px;
                            "
                            >{{ abicode }}
</pre
                          >
                          <br />
                        </div>
                        <div class="mb-4">
                          <div
                            class="
                              d-md-flex
                              justify-content-between
                              align-items-center
                              bg-white-content
                              py-2
                            "
                          >
                            <h4 class="card-header-title">
                              <i class="fa fa-code text-secondary mr-1"></i
                              >Contract Creation Code
                            </h4>
                          </div>
                          <pre
                            class="wordwrap"
                            style="
                              height: 200px;
                              max-height: 400px;
                              margin-top: 5px;
                            "
                          ><div id="verifiedbytecode2">{{createcode}}</div></pre>
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="readContract"
                    style="display: none"
                  >
                    <div
                      id="loadingReadContractframe"
                      style="position: absolute; left: 50%; margin-left: -31px"
                    >
                      <div id="overlayReadContract" class="py-3 text-center">
                        <img
                          src="/images/main/loadingblock.svg"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    <div class="table-responsive" style="visibility: hidden">
                      <iframe
                        width="100%"
                        id="readcontractiframe"
                        src=""
                        frameborder="0"
                        scrolling="no"
                        style="height: 600px; padding: 0px 0.5px"
                      ></iframe>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="writeContract"
                    style="display: none"
                  >
                    <div
                      id="loadingWriteContractframe"
                      style="position: absolute; left: 50%; margin-left: -31px"
                    >
                      <div id="overlayWriteContract" class="py-3 text-center">
                        <img
                          src="/images/main/loadingblock.svg"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    <div class="table-responsive" style="visibility: hidden">
                      <iframe
                        width="100%"
                        id="writecontractiframe"
                        src=""
                        frameborder="0"
                        scrolling="no"
                        style="
                          height: 600px;
                          min-height: 600px;
                          padding: 0px 0.5px;
                        "
                      ></iframe>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="readProxyContract"
                    style="display: none"
                  >
                    <div>
                      <span id="ContentPlaceHolder1_readProxyMessage"></span>
                    </div>
                    <br />
                    <div
                      id="loadingReadProxyContractframe"
                      style="position: absolute; left: 50%; margin-left: -31px"
                    >
                      <div
                        id="overlayReadProxyContract"
                        class="py-3 text-center"
                      >
                        <img
                          src="/images/main/loadingblock.svg"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    <div class="table-responsive" style="visibility: hidden">
                      <iframe
                        width="100%"
                        id="readproxycontractiframe"
                        src=""
                        frameborder="0"
                        scrolling="yes"
                        style="height: 600px"
                      ></iframe>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="writeProxyContract"
                    style="display: none"
                  >
                    <div>
                      <span id="ContentPlaceHolder1_writeProxyMessage"></span>
                    </div>
                    <br />
                    <div
                      id="loadingWriteProxyContractframe"
                      style="position: absolute; left: 50%; margin-left: -31px"
                    >
                      <div
                        id="overlayWriteProxyContract"
                        class="py-3 text-center"
                      >
                        <img
                          src="/images/main/loadingblock.svg"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    <div class="table-responsive" style="visibility: hidden">
                      <iframe
                        width="100%"
                        id="writeproxycontractiframe"
                        src=""
                        frameborder="0"
                        scrolling="yes"
                        style="height: 600px; min-height: 600px"
                      ></iframe>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="readCustomContract"
                    style="display: none"
                  >
                    <div>
                      <span id="ContentPlaceHolder1_readCustomMessage"></span>
                    </div>
                    <div
                      id="loadingReadCustomContractframe"
                      style="position: absolute; left: 50%; margin-left: -31px"
                    >
                      <div
                        id="overlayReadCustomContract"
                        class="py-3 text-center"
                      >
                        <img
                          src="/images/main/loadingblock.svg"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    <div class="table-responsive" style="visibility: hidden">
                      <iframe
                        width="100%"
                        id="readcustomcontractiframe"
                        src=""
                        frameborder="0"
                        scrolling="yes"
                        style="height: 600px"
                      ></iframe>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="writeCustomContract"
                    style="display: none"
                  >
                    <div>
                      <span id="ContentPlaceHolder1_writeCustomMessage"></span>
                    </div>
                    <div
                      id="loadingWriteCustomContractframe"
                      style="position: absolute; left: 50%; margin-left: -31px"
                    >
                      <div
                        id="overlayWriteCustomContract"
                        class="py-3 text-center"
                      >
                        <img
                          src="/images/main/loadingblock.svg"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    <div class="table-responsive" style="visibility: hidden">
                      <iframe
                        width="100%"
                        id="writecustomcontractiframe"
                        src=""
                        frameborder="0"
                        scrolling="yes"
                        style="height: 600px; min-height: 600px"
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade show"
                  id="holders"
                  role="tabpanel"
                  aria-labelledby="transactions-tab"
                >
                  <div
                    class="
                      d-flex
                      flex-wrap flex-xl-nowrap
                      text-nowrap
                      align-items-center
                      ml-auto
                    "
                  ></div>
                  <div
                    id="ContentPlaceHolder1_topPageDiv"
                    class="d-md-flex justify-content-between mb-4"
                  >
                    <p class="mb-2 mb-md-0">
                      <span class="d-flex align-items-center">
                        <i
                          id="spinwheel"
                          class="fa fa-spin fa-spinner fa-1x fa-pulse mr-1"
                          style="display: none"
                        ></i>
                        Top 1,000 holders(From a total of
                        {{ holders_total }} holders)
                      </span>
                      <!-- <span v-show="addr != undefined"
                        >account address: {{ addr }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <span v-show="addr != undefined"
                        >account balance: {{ balance }}</span
                      > -->
                    </p>

                    <nav aria-label="page navigation">
                      <ul class="pagination pagination-sm mb-0">
                        <li
                          class="page-item"
                          :class="{ disabled: page_holders == 0 || !clickFlag }"
                        >
                          <span
                            class="page-link"
                            @click="
                              page_holders = 0;
                              changePageHolders();
                            "
                            >First</span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{ disabled: page_holders == 0 || !clickFlag }"
                        >
                          <span
                            @click="
                              page_holders = page_holders - 1;
                              changePageHolders();
                            "
                            class="page-link"
                            ><i class="fa fa-chevron-left small"></i></span
                          ><span class="sr-only">Previous</span>
                        </li>
                        <li class="page-item">
                          <span class="page-link text-nowrap"
                            >Page
                            <strong class="font-weight-medium">{{
                              page_holders + 1
                            }}</strong>
                            of
                            <strong class="font-weight-medium">{{
                              holders_allPages
                            }}</strong></span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{
                            disabled:
                              page_holders + 1 == holders_allPages ||
                              !clickFlag,
                          }"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Go to Next"
                        >
                          <span
                            class="page-link"
                            @click="
                              page_holders = page_holders + 1;
                              changePageHolders();
                            "
                            aria-label="Next"
                            ><span aria-hidden="True"
                              ><i class="fa fa-chevron-right small"></i
                            ></span>
                            <span class="sr-only">Next</span></span
                          >
                        </li>
                        <li
                          class="page-item"
                          :class="{
                            disabled:
                              page_holders + 1 == holders_allPages ||
                              !clickFlag,
                          }"
                        >
                          <span
                            @click="
                              page_holders = holders_allPages - 1;
                              changePageHolders();
                            "
                            class="page-link"
                            ><span aria-hidden="True">Last</span>
                            <span class="sr-only">Last</span></span
                          >
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="table-responsive mb-2 mb-md-0" id="paywall_mask">
                    <table class="table table-hover">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" width="1">Rank</th>
                          <th scope="col" widtd="500">Address</th>
                          <th scope="col">
                            <i class="fa fa-angle-down text-secondary"></i>
                            Balance
                          </th>
                          <th scope="col" width="250">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in holders_list" :key="index">
                          <td>
                            {{ item.order }}
                          </td>
                          <td>
                            <span style="white-space: nowrap">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="contract"
                                placement="top"
                              >
                                <i
                                  class="far fa-file-text-o text-secondary"
                                  data-toggle="tooltip"
                                  data-boundary="viewport"
                                  data-html="true"
                                  title=""
                                  data-original-title="Contract"
                                  v-if="item.is_contract"
                                ></i></el-tooltip
                              ><a :href="'/txs?address=' + item.address">{{
                                item.name == "" ? item.address : item.name
                              }}</a></span
                            >
                          </td>
                          <!-- <td>{{}}</td>
                      <td>{{}}</td> -->
                          <td>{{ item.balance }}</td>
                          <td>{{ item.price }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    id="signInPopUp"
                    class="row justify-content-center align-items-center"
                    style="display: none"
                  >
                    <div class="col d-none d-lg-block">
                      <img
                        class="img-fluid mx-4"
                        src="../assets/images/svg/bg/bg1-left-side.svg?v=20.4.3.0"
                        alt=""
                      />
                    </div>
                    <div class="col-10 col-sm-8 col-lg-7 col-xl-5">
                      <div class="text-center py-5 my-5-alt">
                        <h4 class="font-weight-bold">
                          Sign In for Continued Access
                        </h4>
                        <p class="h5 text-secondary mb-4">
                          No worries, it's absolutely <strong>free</strong> and
                          takes a minute!
                          <br class="-none d-md-inline-block" />
                          Register a
                          <a class="text-primary" href="/register"
                            >Free Account</a
                          >
                          today.
                        </p>
                        <div class="mb-3"></div>
                      </div>
                    </div>
                    <div class="col d-none d-lg-block">
                      <img
                        class="img-fluid mx-4"
                        src="../assets/images/svg/bg/bg1-right-side.svg?v=20.4.3.0"
                        alt=""
                      />
                    </div>
                  </div>
                  <div id="ContentPlaceHolder1_pageRecords">
                    <form
                      method="post"
                      action="./txs?block=13085066"
                      id="ctl00"
                    >
                      <div class="aspNetHidden">
                        <input
                          type="hidden"
                          name="__EVENTTARGET"
                          id="__EVENTTARGET"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__EVENTARGUMENT"
                          id="__EVENTARGUMENT"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__LASTFOCUS"
                          id="__LASTFOCUS"
                          value=""
                        />
                        <input
                          type="hidden"
                          name="__VIEWSTATE"
                          id="__VIEWSTATE"
                          value="xqABbyVuV6MaSdognYdteKXGMRazc0ooDVyZEbMvHuw1UCGIabHJ6GBKjtr4Hrd2/EsPjeCVTfAgPnKr+a755Qx0wqvCy2+81UfxIUB+3ZE="
                        />
                      </div>

                      <div class="aspNetHidden">
                        <input
                          type="hidden"
                          name="__VIEWSTATEGENERATOR"
                          id="__VIEWSTATEGENERATOR"
                          value="FCB51872"
                        />
                        <input
                          type="hidden"
                          name="__EVENTVALIDATION"
                          id="__EVENTVALIDATION"
                          value="PkOLupSnqdb+BX7szq7Ax3jWBMMjdyt0rEXbLfZjVZiJhkXRSAIto2svc7OrQ753SJvb+Wgw6DBz7wATxUAjoDwlbRBD+ZplCP8DkjGiqoL8q7CbAk68BeiAPzKct3MQVnOkt4k60ddplbGoS8XGfq60DeiCXfm2fC/bBLPGeM9I6idyEBfVFrBAjNyKBQddynGVKIkuH6KOc6vWcPQHIQ=="
                        />
                      </div>
                      <div class="d-md-flex justify-content-between my-3">
                        <div
                          class="
                            d-flex
                            align-items-center
                            text-secondary
                            mb-2 mb-md-0
                          "
                        >
                          Show
                          <select
                            name="ctl00$ContentPlaceHolder1$ddlRecordsPerPage"
                            v-model="per_page_holders"
                            @change="changePerPageHolders"
                            id="ContentPlaceHolder1_ddlRecordsPerPage"
                            class="custom-select custom-select-xs mx-2"
                          >
                            <option value="10">10</option>
                            <option selected="selected" value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          Records
                        </div>
                        <nav aria-label="page navigation">
                          <ul class="pagination pagination-sm mb-0">
                            <li
                              class="page-item"
                              :class="{
                                disabled: page_holders == 0 || !clickFlag,
                              }"
                            >
                              <span
                                class="page-link"
                                @click="
                                  page_holders = 0;
                                  changePageHolders();
                                "
                                >First</span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled: page_holders == 0 || !clickFlag,
                              }"
                            >
                              <span
                                @click="
                                  page_holders = page_holders - 1;
                                  changePageHolders();
                                "
                                class="page-link"
                                ><i class="fa fa-chevron-left small"></i></span
                              ><span class="sr-only">Previous</span>
                            </li>
                            <li class="page-item">
                              <span class="page-link text-nowrap"
                                >Page
                                <strong class="font-weight-medium">{{
                                  page_holders + 1
                                }}</strong>
                                of
                                <strong class="font-weight-medium">{{
                                  holders_allPages
                                }}</strong></span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled:
                                  page_holders + 1 == holders_allPages ||
                                  !clickFlag,
                              }"
                              data-toggle="tooltip"
                              title=""
                              data-original-title="Go to Next"
                            >
                              <span
                                class="page-link"
                                @click="
                                  page_holders = page_holders + 1;
                                  changePageHolders();
                                "
                                aria-label="Next"
                                ><span aria-hidden="True"
                                  ><i class="fa fa-chevron-right small"></i
                                ></span>
                                <span class="sr-only">Next</span></span
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled:
                                  page_holders + 1 == holders_allPages ||
                                  !clickFlag,
                              }"
                            >
                              <span
                                @click="
                                  page_holders = holders_allPages - 1;
                                  changePageHolders();
                                "
                                class="page-link"
                                ><span aria-hidden="True">Last</span>
                                <span class="sr-only">Last</span></span
                              >
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </form>
                  </div>
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      mt-3
                      mb-4
                    "
                  >
                    <div class="d-flex align-items-center text-secondary"></div>
                    <div class="small text-muted"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div id="push"></div>
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        id="emailSubscribeModalBox"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="close close-md"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div class="text-center py-5-alt px-4">
                <div id="emailSubscribeModalBoxText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <comfooter></comfooter>
  </div>
</template>
<script src="../"></script>

<script>
// @ is an alias to /src
import comheader from "@/components/serach_header";
import comfooter from "@/components/comfooter";
import contractAddress from "@/contract/address";
import editor from "vue2-ace-editor";
import { if_contract_address, get_contract_source_code } from "@/API/api";
import {
  get_transaction_list,
  get_node_info,
  get_transaction_by_block_height,
  get_transaction_by_from_or_to,
  get_account_balance,
  get_detail_by_contract_address,
  get_asset_transaction_by_address,
  get_wpsc_list,
} from "@/API/api";

import { timeFrom } from "@/Utils/timeFrom";
import beautify_js from "js-beautify";
import tokens from "../contract/tokens.json";
// const ethers = require("ethers");
import { prc20tokens } from "../contract/prc20tokens";
import { ethers } from "ethers";
import prctokens from "../contract/tokens.json";

import Web3 from "web3";

export default {
  name: "Home",
  components: {
    comheader,
    comfooter,
    editor,
  },
  data() {
    return {
      is_pool: true,
      isSocial: false,
      isUSDT: false,
      balancewpsc: "",
      balancewdc: "",
      balancelp: "",
      editorOptions: {
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableLiveAutocompletion: true,
        readOnly: true,
        showPrintMargin: false,
        wrapBehavioursEnabled: true,
      },

      runs: 0,
      evmVersion: "",
      ifVeri: false,
      contractname: "",
      createcode: "",
      abicode: "",
      sourceList: [],
      li1_active: true,
      li2_active: false,
      li3_active: false,
      li4_active: false,
      s_token_name: "",
      slideInUp: false,
      isSlideUp: false,
      isHidden: true,
      tokenList: [],
      tokenList_copy: [],
      nodeData: {}, //获取节点信息
      page: 0,
      per_page: 25,
      page_prc: 0,
      per_page_prc: 25,
      page_holders: 0,
      per_page_holders: 25,
      txList: [],
      totalTxs: 0,
      allPages: 1,
      prc20_list: [],
      prc20_totalTxs: 0,
      prc20_allPages: 1,
      holders_list: [],
      holders_total: 0,
      holders_allPages: 1,
      flag: 1,
      height: "",
      addr: "",
      balance: "0",
      query: {},
      pscValue: "",
      balance: "",
      creator: "",
      tx_hash: "",
      is_prc20: "",
      prc_decimal: "",
      prc_name: "",
      prc_total_supply: "",
      isShowAddress: false,
      ifContract: false,
      isSuccess_copy: false,
      token_address: "",
      clickFlag: true,
      isholders: false,
    };
  },
  filters: {
    decimalNew(v) {
      return ethers.utils.commify(v);
    },
    str_Address(address) {
      let str1 = address.slice(0, 10);
      let str2 = address.slice(-4);

      return str1 + "..." + str2;
    },
    formatNum(num) {
      if (!/^(-|\+)?(\d+)(\.\d+)?$/.test(num)) {
        return num;
      }
      var sign = RegExp.$1;
      var middle = RegExp.$2;
      var decimals = RegExp.$3;
      var reg = /(\d)(\d{3})(,|$)/;
      while (reg.test(middle)) {
        middle = middle.replace(reg, "$1,$2$3");
      }
      return sign + "" + middle + "" + decimals;
    },

    timeFromat(date) {
      return timeFrom(date);
    },
    fromWei(value) {
      if (value == null) {
        return 0;
      }

      var web3 = new Web3();
      var value = web3.utils.fromWei(value.toString(), "ether");

      return parseFloat(parseFloat(value).toFixed(8, 2));
    },
    scientificNotationToString(param) {
      let strParam = String(param);
      let flag = /e/.test(strParam);
      if (!flag) return param;

      // 指数符号 true: 正，false: 负
      let sysbol = true;
      if (/e-/.test(strParam)) {
        sysbol = false;
      }
      // 指数
      let index = Number(strParam.match(/\d+$/)[0]);
      // 基数
      let basis = strParam.match(/^[\d]+/)[0].replace(/\./, "");

      if (sysbol) {
        return basis.padEnd(index + 1, 0);
      } else {
        return basis.padStart(index + basis.length, 0).replace(/^0/, "0.");
      }
    },
  },

  watch: {
    s_token_name() {
      let that = this;
      if (that.s_token_name == "") {
        that.tokenList_copy = that.tokenList;
      }

      let arr = [];
      that.tokenList.filter((item) => {
        if (
          item.name.toLowerCase().indexOf(that.s_token_name.toLowerCase()) != -1
        ) {
          arr.push(item);
        }
      });

      [...that.tokenList_copy] = [...arr];
    },
  },
  created() {
    let that = this;

    that.addr = that.$route.query.address;

    if (that.addr) {
      if (
        that.addr.toLowerCase() == contractAddress.USDT.toLowerCase() ||
        that.addr.toLowerCase() == contractAddress.WDC.toLowerCase() ||
        that.addr.toLowerCase() == contractAddress.WPSC.toLowerCase()
      ) {
        that.isUSDT = true;
      }
    }
  },

  async mounted() {
    let that = this;
    that.height = that.$route.query.height;
    that.addr = that.$route.query.address;
    that.ifContractAddress();
    that.getContractSource();

    if (that.addr) {
      that.getAddressDetail();
      that.isShowAddress = true;
    } else {
      that.isShowAddress = false;
    }

    // that.get_prc20_list();
    that.ifContractAddress();
    that.showBlock();
    that.getNodeData();
    that.get_transaction_list();
    if (that.addr && that.addr.toLowerCase() == tokens.WPSC.toLowerCase()) {
      that.getWpscList();
    }

    that.getAccountBalance();

    //getTransactionReceipt
    // var web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.ninicoin.io/"));
    // let aaaa = await web3.eth.getTransactionReceipt('0xa5311f0734daa7c003456920aed3c21e47d1c6834e674871e0f1cef5dab613cb');
  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/html");
      require("brace/mode/javascript"); //language
      require("brace/mode/less");
      require("brace/mode/java");
      require("brace/mode/csharp");
      require("brace/theme/chrome");
      require("brace/snippets/javascript"); //snippet
      // this.editor.setOption("wrap", "free");
    },
    showUpdateInfo() {
      let that = this;
      if (that.isHidden) {
        that.isSlideUp = true;
        that.isHidden = false;
      } else {
        that.isSlideUp = false;
        that.isHidden = true;
      }
    },
    toVerifyAddress() {
      let that = this;

      that.$router.push({
        name: "verifyaddress",
        params: {
          address: that.addr,
          creator: that.creator,
        },
      });
    },
    toVerify() {
      let that = this;
      that.$router.push({
        name: "sourcecode",
        params: {
          address: that.addr,
        },
      });
    },
    ifSlideInUp() {
      let that = this;
      if (!that.slideInUp) {
        document
          .querySelector("#availableBalanceClick")
          .classList.add("slideInUp");
        document
          .querySelector("#availableBalanceClick")
          .classList.remove("u-unfold--hidden");
        that.slideInUp = true;
      } else {
        document
          .querySelector("#availableBalanceClick")
          .classList.add("u-unfold--hidden");
        document
          .querySelector("#availableBalanceClick")
          .classList.remove("slideInUp");
        that.slideInUp = false;
      }
    },
    async ifContractAddress() {
      let that = this;
      if (that.addr) {
        let res = await if_contract_address(that.addr);
        if (res) {
          that.ifContract = true;
        } else {
          that.ifContract = false;
        }
      }
    },
    onCopy: function(e) {
      let that = this;

      that.isSuccess_copy = true;
      that.timer = setTimeout(function() {
        that.isSuccess_copy = false;
      }, 2000);
    },
    onError: function(e) {
      let that = this;
      this.$message({
        showClose: true,
        message: "copy failed",
        type: "warning",
      });
    },
    getAccountBalance() {
      let that = this;

      if (
        that.$route.query.address != "" &&
        that.$route.query.address != null &&
        that.$route.query.address != undefined
      ) {
        get_account_balance(that.$route.query.address).then((res) => {
          res.data
            ? (that.balance = ethers.utils.formatEther(res.data.balance))
            : "";
        });
      }
    },
    async seeUSDTTotal() {
      let that = this;

      let contract = that.getContractPRC(prctokens.mainUSDT);
      let res = await contract.totalSupply();
      that.prc_total_supply = ethers.utils.formatUnits(res.toString(), 6);
    },
    getContractPRC(address) {
      const provider = new ethers.providers.JsonRpcProvider(
        contractAddress.mainrpc
      );
      // let provider = getProvider();
      let ercabi = [
        {
          inputs: [],
          name: "totalSupply",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "tokenOwner",
              type: "address",
            },
          ],
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "balance",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [
            {
              internalType: "uint8",
              name: "",
              type: "uint8",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "symbol",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
      ];
      let contract = new ethers.Contract(address, ercabi, provider);
      return contract;
    },
    async getAddressDetail() {
      let that = this;
      await that.seeTokensBalanceNew();
      that.tokenList_copy = that.tokenList;
      let res = await get_detail_by_contract_address(that.addr); 
      if (res.data.tokens && !res.data.balance) {
        that.tokenList = res.data.tokens;
      } else {
        // that.balance = res.data.balance;
        // that.pscValue = res.data.psc_value;
        // that.is_prc20 = res.data.is_prc20;

        //WPSC
        if (
          that.addr.toLowerCase() == contractAddress.WPSC.toLowerCase() &&
          Number(res.data.balance) > 79000000000000
        ) {
          that.balance = "79000000000000";
          let psctotal = Number(res.data.psc_value.slice(1));
          let pscprice = psctotal / Number(res.data.balance);
          let pscvalue = pscprice * Number(that.balance);
          that.pscValue = `$${pscvalue}`;
          that.is_prc20 = res.data.is_prc20;
        } else {
          that.balance = res.data.balance;
          that.pscValue = res.data.psc_value;
          that.is_prc20 = res.data.is_prc20;
        }
      }
      //WPSC
      if (that.addr.toLowerCase() == contractAddress.WPSC.toLowerCase()) {
        that.isholders = true;
      }
      if (res.data.is_pool) {
        that.is_pool = res.data.is_pool;
      } else {
        that.is_pool = false;
      }

      // 0 or 8 address
      if (
        that.addr == "0x0000000000000000000000000000000000000000" ||
        that.addr == "0x8888888888888888888888888888888888888888"
      ) {
        await that.getTokenBalance(that.addr);
        that.tokenList = [
          {
            balance: that.balancewpsc,
            code: contractAddress.WPSC.toLowerCase(),
            decimal: 18,
            name: "Wrapped Psc",
            pic: null,
          },
          {
            balance: that.balancewdc,
            code: contractAddress.WDC.toLowerCase(),
            decimal: 18,
            name: "WDC",
            pic: null,
          },
          {
            balance: that.balancelp,
            code: contractAddress.WDC.toLowerCase(),
            decimal: 18,
            name: "CATUSDT-LP",
            pic: null, 
          },
        ];

        that.tokenList_copy = that.tokenList;
      }

      if (res.data.creator) {
        that.creator = res.data.creator;
        that.tx_hash = res.data.tx_hash;
      }
      //USDT WDC WPSC
      if (res.data.decimal) {
        if (that.addr.toLowerCase() == contractAddress.USDT.toLowerCase()) {
          await that.seeUSDTTotal();
        }
        if (that.addr.toLowerCase() == contractAddress.WDC.toLowerCase()) {
          that.prc_total_supply = "590000000";
        }
        if (that.addr.toLowerCase() == contractAddress.WPSC.toLowerCase()) {
          that.prc_total_supply = "100000000000000";
        }
        that.prc_decimal = res.data.decimal;
        that.prc_name = res.data.name;

        if (
          that.addr.toLowerCase() == contractAddress.USDT.toLowerCase() &&
          that.addr.toLowerCase() == contractAddress.WDC.toLowerCase() &&
          that.addr.toLowerCase() == contractAddress.WPSC.toLowerCase()
        )
          that.prc_total_supply = res.data.total_supply;
      }
    },
    click_tab(n) {
      let that = this;
      if (document.querySelector("#nav_tabs").children.length == 1) return;
      if (n == 1) {
        that.li1_active = true;
        that.li2_active = false;
        that.li3_active = false;
        that.li4_active = false;
      } else if (n == 2) {
        that.li1_active = false;
        that.li2_active = true;
        that.li3_active = false;
        that.li4_active = false;
      } else if (n == 3) {
        that.li1_active = false;
        that.li2_active = false;
        that.li3_active = true;
        that.li4_active = false;
      } else if (n == 4) {
        that.li1_active = false;
        that.li2_active = false;
        that.li3_active = false;
        that.li4_active = true;
      }
    },

    async getTokenBalance(account) {
      let that = this;
      const abi = [
        {
          constant: true,
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address",
            },
          ],
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [ 
          ],
          name: "symbol",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
      ];
      const provider = new ethers.providers.JsonRpcProvider(
        contractAddress.rpc
      );
      var constractwpsc = new ethers.Contract(
        contractAddress.WPSC,
        abi,
        provider
      );
      var constractwdc = new ethers.Contract(
        contractAddress.WDC,
        abi,
        provider
      );
      var constractlp = new ethers.Contract(contractAddress.LP, abi, provider);
      that.balancewpsc = await constractwpsc.balanceOf(account);
      that.balancewdc = await constractwdc.balanceOf(account);
      that.balancelp = await constractlp.balanceOf(account); 
      that.balancewpsc = that.balancewpsc.toString();
      that.balancewdc = that.balancewdc.toString();
      that.balancelp = that.balancelp.toString();
    },
    decimal(v, decimal) {
      if (
        Number.isInteger(
          Number(
            ethers.utils.formatUnits(
              ethers.BigNumber.from(v.toString()),
              decimal
            )
          )
        )
      ) {
        return ethers.utils.commify(
          parseInt(
            ethers.utils.formatUnits(
              ethers.BigNumber.from(v.toString()),
              decimal
            )
          )
        );
      }
      return ethers.utils.commify(
        ethers.utils.formatUnits(ethers.BigNumber.from(v.toString()), decimal)
      );
    },

    decimalBalance(v, decimal) {
      if (v)
        return ethers.utils.commify(ethers.utils.formatUnits(v.toString(), 18));
    },

    async changePerPage() {
      let that = this;
      that.clickFlag = false;
      that.page = 0;
      await that.get_transaction_list();
      that.clickFlag = true;
    },
    async changePage() {
      let that = this;
      that.clickFlag = false;
      await that.get_transaction_list();
      that.clickFlag = true;
    },

    async changePerPagePrc() {
      let that = this;
      that.clickFlag = false;
      that.page = 0;
      await that.get_prc20_list();
      that.clickFlag = true;
    },
    async changePagePrc() {
      let that = this;
      that.clickFlag = false;
      await that.get_prc20_list();
      that.clickFlag = true;
    },

    async changePerPageHolders() {
      let that = this;
      that.clickFlag = false;
      that.page_holders = 0;
      await that.getWpscList();
      that.clickFlag = true;
    },
    async changePageHolders() {
      let that = this;
      that.clickFlag = false;
      await that.getWpscList();
      that.clickFlag = true;
    },
    getNodeData() {
      let that = this;
      get_node_info().then((res) => {
        that.nodeData = res;
      });
    },
    async get_transaction_list() {
      let that = this;
      if (
        that.$route.query.height == undefined &&
        that.$route.query.address == undefined
      ) {
        await get_transaction_list(that.per_page, that.page).then((res) => {
          that.txList = res.data.content;
          that.totalTxs = res.data.totalElements;
          that.allPages = res.data.totalPages;
        });
      } else if (
        that.$route.query.height != undefined &&
        that.$route.query.address == undefined
      ) {
        await get_transaction_by_block_height(
          that.per_page,
          that.page,
          that.$route.query.height
        ).then((res) => {
          that.txList = res.data.content;
          that.totalTxs = res.data.totalElements;
          that.allPages = res.data.totalPages;
        });
      } else {
        await get_transaction_by_from_or_to(
          that.per_page,
          that.page,
          that.$route.query.address
        ).then((res) => {
          that.txList = res.data.content;
          that.totalTxs = res.data.totalElements;
          that.allPages = res.data.totalPages;
          //  if (
          //   that.addr.toLowerCase() ==
          //   "0xebaBd3ee4E4E2B7ba378c3EbCB59fbe92A00DEF0".toLowerCase()
          // ) {
          //   that.txList = [];
          //   that.totalTxs = 0;
          //   that.allPages = 0;
          // }
        });
      }
    },

    async get_prc20_list() {
      let that = this;

      await get_asset_transaction_by_address(
        that.$route.query.address,
        that.per_page_prc,
        that.page_prc,
        ""
      ).then((res) => {
        that.prc20_list = res.data.content;
        that.prc20_totalTxs = res.data.totalElements;

        that.prc20_allPages = res.data.totalPages;
      });
    },

    async getWpscList() {
      let that = this;

      await get_wpsc_list(that.per_page_holders, that.page_holders).then(
        (res) => {
          that.holders_list = res.data.content;
          that.holders_total = res.data.totalElements;
          // that.holders_allPages = res.data.totalPages;
          that.holders_allPages = Math.ceil(
            1000 / Number(that.per_page_holders)
          );
        }
      );
    },
    searchTxns(e) {
      let that = this;
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        get_asset_transaction_by_address(
          that.$route.query.address,
          that.per_page_prc,
          that.page_prc,
          that.token_address
        ).then((res) => {
          that.prc20_list = res.data.content;
          that.prc20_totalTxs = res.data.totalElements;
          that.prc20_allPages = res.data.totalPages;
        });
      }
    },
    async getNodeData1(obj) {
      let that = this;
      get_node_info().then((res) => {
        that.nodeData = res;
        var web3 = new Web3(
          new Web3.providers.HttpProvider(that.nodeData.node_url)
        );
        web3.eth.getTransaction(obj.hash).then((res) => {
          obj.value = res.value;
        });
      });
    },
    showBlock() {
      let that = this;

      if (that.$route.query.height == undefined) {
        that.flag = 0;
      }
    },

    getContractERC(address) {
      const provider = new ethers.providers.JsonRpcProvider(
        contractAddress.rpc
      );
      // let provider = getProvider();
      let ercabi = [
        {
          inputs: [
            {
              internalType: "address",
              name: "tokenOwner",
              type: "address",
            },
          ],
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "balance",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [
            {
              internalType: "uint8",
              name: "",
              type: "uint8",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "symbol",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
      ];
      let contract = new ethers.Contract(address, ercabi, provider);
      return contract;
    },
    getContractSearch(address) {
      const provider = new ethers.providers.JsonRpcProvider(
        contractAddress.rpc
      );
      let newabi = [
        {
          inputs: [
            {
              internalType: "address[]",
              name: "_addrs",
              type: "address[]",
            },
            {
              internalType: "address",
              name: "_user",
              type: "address",
            },
          ],
          name: "viewTokens",
          outputs: [
            {
              internalType: "uint256[]",
              name: "",
              type: "uint256[]",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
      ];
      let contract = new ethers.Contract(address, newabi, provider);
      return contract;
    },

    async seeTokensBalance() {
      let that = this;
      let arr = [];

      var tokennames = tokens;
      for (let name of Object.keys(tokennames)) {
        let contract = that.getContractERC(tokennames[name]);
        let symbol = name;
        let decimals;
        name == "WDC" ? (decimals = 8) : (decimals = 18);
        let balance = await contract.balanceOf(that.addr);
        let obj = {
          name: symbol,
          code: tokennames[name].toLowerCase(),
          decimal: decimals,
          balance: balance.toString(),
          pic: null,
        };
        if (Number(balance.toString()) > 0) arr.push(obj);
      }
      that.tokenList = arr;
    },
    //need repair
    async seeTokensBalanceNew() {
      let that = this;
      console.log(11111111111);
      let contract = that.getContractSearch(contractAddress.serchContract);
      console.log(22222222222222);
      let arr = []; 
      let tokens = [
        contractAddress.WPSC,
        contractAddress.USDT,
        contractAddress.WDC,
        contractAddress.PolyDao,
        contractAddress.CAT,  
        contractAddress.PULP,
      ];
      let names = ["WPSC", "USDT", "WDC", "POLYDAO",'CAT','PSC-USDT-LP'];
      //GGA
      if (
        that.addr.toLowerCase() ==
        "0x3b75e35dF53bBB22a63c09F88d23135C2Ced8d9f".toLowerCase()
      ) {
        tokens.push(contractAddress.GGA);
        names.push("GGA");
        tokens.push(contractAddress.OlDWPSC), names.push("WPSC");
      }
      console.log(contract);
      let res = await contract.viewTokens(tokens, that.addr);
      for (let i = 0; i < res.length; i++) {
        let decimal = 18;
        // names[i] == "WDC" ? (decimal = 8) : (decimal = 18);
        let obj = {
          name: names[i],
          code: tokens[i],
          decimal: decimal,
          balance: res[i].toString(),
          pic: null,
        };
        if (Number(res[i].toString()) > 0) arr.push(obj);
      }
      that.tokenList = arr;
      let result = await get_detail_by_contract_address(that.addr);
      if (result.data.tokens && !result.data.balance) {
        that.tokenList = result.data.tokens;
      }
    },

    async getContractSource() {
      let that = this;
      let res = await get_contract_source_code(that.addr);

      if (res.data) {
        that.ifVeri = true;
        that.sourceList = res.data.sources;
        that.abicode = res.data.abi;
        that.createcode = res.data.code;
        that.contractname = res.data.contractName;
        that.evmVersion = res.data.evmVersion;
        if (that.sourceList) {
          that.sourceList.forEach((item) => {
            item.content = beautify_js(item.content);
          });
        }
      }
    },
  },
};
</script>
<style>
.dropdown-toggle:after {
  content: "";
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
